export default "__VITE_ASSET__28146ea9__"